

























































import CreateDialog from './CreateDialog.vue'
import PasswordField from '@/components/PasswordField.vue'
import { required } from '@/utils/validators'
import { changePassword } from '@/api/Auth/auth.api'
import { crudMixin } from '@/utils/mixins/crudMixin'
import { VueForm } from '@/utils/interfaces'
import { TranslateResult } from 'vue-i18n'

export default crudMixin.extend({
  components: {
    appCreateDialog: CreateDialog,
    appPasswordField: PasswordField,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      rules: {
        required: (v: string) =>
          required(v) || this.$t('validation.password.required'),
        identical: () =>
          this.$data.crud.new_password1 === this.$data.crud.new_password2 ||
          this.$t('validation.password.must-match'),
        min: (v: string) =>
          (v && v.length > 7) || this.$t('validation.password.too-short'),
        num: (v: string) => {
          const number = /[0-9]/
          return (
            number.test(v) ||
            this.$t('validation.password.must-contain-numbers')
          )
        },
        letter: (v: string) => {
          const letter = /[a-zA-Z]/
          return (
            letter.test(v) ||
            this.$t('validation.password.must-contain-letters')
          )
        },
      },
      defaultCrud: {
        old_password: '',
        new_password1: '',
        new_password2: '',
      },
      crud: {
        old_password: '',
        new_password1: '',
        new_password2: '',
      },
      loading: false,
      wrongCred: false,
      modified: false,
      errors: {
        old_password: [],
        new_password1: [],
        new_password2: [],
      },
    }
  },
  computed: {
    errorMessage(): TranslateResult[] {
      const errors = []
      if (this.wrongCred) {
        errors.push(this.$t('validation.password.wrong-password'))
      }
      return errors
    },
  },
  watch: {
    value(value) {
      if (value) {
        this.resetCrud()
        ;(this.$refs.form as VueForm).reset()
      }
    },
  },
  methods: {
    async onSuccess() {
      this.loading = true
      try {
        await changePassword(this.crud)
        this.$emit('input', false)
      } catch (error) {
        this.errors = {
          old_password: [],
          new_password1: [],
          new_password2: [],
        }
        this.errors = Object.assign(this.errors, error.response.data)
        this.wrongCred = true
      } finally {
        this.loading = false
      }
    },
  },
})
